import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___init__impl__jj3mn23p0pea18kbfe7 as _ServerFile___init__impl__jj3mn2,
} from './ServerFile.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function error($this) {
  throw IllegalStateException().o4('Primitive descriptor does not have elements');
}
var ServerFileSerializer$descriptor$1Class;
function ServerFileSerializer$descriptor$1() {
  if (ServerFileSerializer$descriptor$1Class === VOID) {
    class $ {
      constructor() {
        this.g4m_1 = STRING_getInstance();
        this.h4m_1 = 'com.lightningkite.lightningserver.files.ServerFile';
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp.i4m_1 = emptyList();
      }
      s11() {
        return this.g4m_1;
      }
      h10() {
        return this.h4m_1;
      }
      u11() {
        return 0;
      }
      v11(index) {
        error(this);
      }
      w11(name) {
        error(this);
      }
      z11(index) {
        error(this);
      }
      y11(index) {
        error(this);
      }
      x11(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.h4m_1 + ')';
      }
      bz() {
        return this.i4m_1;
      }
    }
    protoOf($).l11 = get_isNullable;
    protoOf($).t11 = get_isInline;
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    ServerFileSerializer$descriptor$1Class = $;
  }
  return ServerFileSerializer$descriptor$1Class;
}
var ServerFileSerializerClass;
function ServerFileSerializer() {
  if (ServerFileSerializerClass === VOID) {
    class $ {
      constructor() {
        ServerFileSerializer_instance = this;
        var tmp = this;
        tmp.j4m_1 = new (ServerFileSerializer$descriptor$1())();
      }
      az() {
        return this.j4m_1;
      }
      k4m(encoder, value) {
        encoder.p14(_ServerFile___get_location__impl__ddyqaq(value));
      }
      oz(encoder, value) {
        return this.k4m(encoder, value instanceof ServerFile() ? value.l2n_1 : THROW_CCE());
      }
      l4m(decoder) {
        return _ServerFile___init__impl__jj3mn2(decoder.h13());
      }
      pz(decoder) {
        return new (ServerFile())(this.l4m(decoder));
      }
    }
    initMetadataForObject($, 'ServerFileSerializer', VOID, VOID, [KSerializer()]);
    ServerFileSerializerClass = $;
  }
  return ServerFileSerializerClass;
}
var ServerFileSerializer_instance;
function ServerFileSerializer_getInstance() {
  if (ServerFileSerializer_instance === VOID)
    new (ServerFileSerializer())();
  return ServerFileSerializer_instance;
}
//region block: exports
export {
  ServerFileSerializer_getInstance as ServerFileSerializer_getInstance2y54t0c6enbya,
};
//endregion

//# sourceMappingURL=ServerFileSerializer.mjs.map
